import ReactDOM from 'react-dom/client'
import App from './App'
import './styles/app.sass'
import { RouterProvider, createBrowserRouter } from 'react-router-dom'
import ErrorPage from './pages/Error'
import { Provider } from 'react-redux'
import { store } from './redux/store'
import DashboardLayout from 'pages/Dashboard'
import OverviewPage from 'pages/Dashboard/Overview'
import BillingPage from 'pages/Billing'
import AssetLogs from 'pages/Dashboard/Portfolio/AssetLogs'
import Discovery from 'pages/Dashboard/Discovery'
import AssetAnalysis from 'pages/Dashboard/AsssetAnalysis'
import Portfolio from 'pages/Dashboard/Portfolio'
import NebulaSearch from 'pages/Dashboard/NebulaSearch'
import { AuthProvider } from "react-oidc-context"
import { setupGlobalLogger } from './utils/logger'


if (process.env.NODE_ENV === 'production') {
 setupGlobalLogger()
}


if (!process.env.REACT_APP_COGNITO_AUTHORITY || !process.env.REACT_APP_COGNITO_CLIENT_ID) {
  throw new Error('Missing Cognito configuration');
}

const AUTHORITY = process.env.REACT_APP_COGNITO_AUTHORITY; 
const CLIENT_ID = process.env.REACT_APP_COGNITO_CLIENT_ID;


// Environment-specific allowed origins
const getAllowedOrigins = () => {
  if (process.env.NODE_ENV === 'production') {
    return ['https://www.astroteklabs.com', 'https://dashboard.astrotek.app'];
  }
  return ['http://localhost:3000'];
};

// Validate redirect URL against whitelist
const validateRedirectUrl = (url) => {
  try {
    const parsedUrl = new URL(url);
    return getAllowedOrigins().includes(parsedUrl.origin);
  } catch {
    return false;
  }
};

// Get safe redirect URI
const getSafeRedirectUri = () => {
  const currentOrigin = window.location.origin;
  
  if (validateRedirectUrl(currentOrigin)) {
    return currentOrigin;
  }
  
  // Fallback to first allowed origin
  return getAllowedOrigins()[0];
};

const cognitoAuthConfig = {
  authority: AUTHORITY,
  client_id: CLIENT_ID,
  redirect_uri: getSafeRedirectUri(),
  response_type: "code",
  scope: "aws.cognito.signin.user.admin email openid phone profile",
};

const router = createBrowserRouter([
 {
   path: '/',
   element: <App />,
   errorElement: <ErrorPage />,
   children: [
     {
       path: '/',
       element: <DashboardLayout />,
       children: [
         {
           path: '/',
           element: <OverviewPage />,
         },
         {
           path: 'discovery',
           element: <Discovery />,
         },
         {
           path: 'portfolio',
           element: <Portfolio />,
         },
         {
           path: 'asset-logs',
           element: <AssetLogs />,
         },
         {
           path: 'asset-analysis',
           element: <AssetAnalysis />,
         },
         {
           path: 'billing',
           element: <BillingPage />,
         },
         {
           path: 'nebula-search',
           element: <NebulaSearch />,
         },
        //  {
        //    path: 'scam-detection',
        //    element: <ScamDetection />,
        //  },
       ],
     },
     // Removed auth routes since using Cognito managed UI
   ],
 },
])

// const rootElement = document.getElementById('root')
// if (rootElement) {
//  const root = ReactDOM.createRoot(rootElement)
//  root.render(
//    <React.StrictMode>
//      <AuthProvider {...cognitoAuthConfig}>
//        <Provider store={store}>
//          <RouterProvider router={router} />
//        </Provider>
//      </AuthProvider>
//    </React.StrictMode>
//  )
// } else {
//  console.error('Root element not found')
// }

// RUN OUT OF STRICT MODE (STOP DUPLICATE RENDERS)
const rootElement = document.getElementById('root')
if (rootElement) {
const root = ReactDOM.createRoot(rootElement)
root.render(
  <AuthProvider {...cognitoAuthConfig}>
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  </AuthProvider>
)
} else {
console.error('Root element not found')
}
